import { render, staticRenderFns } from "./BarangayAnalytics.vue?vue&type=template&id=57c24a49"
import script from "./BarangayAnalytics.vue?vue&type=script&lang=js"
export * from "./BarangayAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports